export const orgHasSetting = (orgData, setting) => {
  return orgData?.settings?.indexOf(setting) > -1 || false;
};
